import React from "react";

import {
  ALL_EVENT_TYPES,
  DATE_FILTER_OPTIONS,
  DATE_FILTERS,
} from "../data/convocationsAdmin.constants";

import {
  pluralize,
} from "../utils/convocationsAdmin.utils";

function FilterChip({
  children,
  tone = "blue",
}) {
  const colors = {
    blue:
      "bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300",

    emerald:
      "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
  };

  return (
    <span
      className={`rounded-full px-3 py-1.5 text-xs font-medium ${
        colors[tone]
      }`}
    >
      {children}
    </span>
  );
}

export default function ConvocationsResultsSummary({
  resultCount,
  displayedCount,
  search,
  selectedType,
  selectedDateFilter,
  onlyWithConvocations,
  page,
  pageCount,
}) {
  const dateLabel = DATE_FILTER_OPTIONS.find(
    (option) =>
      option.value === selectedDateFilter,
  )?.label;

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-wrap items-center gap-2">
        <span className="rounded-full bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-700 dark:bg-slate-800 dark:text-slate-200">
          {resultCount}{" "}
          {pluralize(
            resultCount,
            "événement",
          )}
        </span>

        {selectedType !== ALL_EVENT_TYPES && (
          <FilterChip>
            Type : {selectedType}
          </FilterChip>
        )}

        {selectedDateFilter !== DATE_FILTERS.ALL && (
          <FilterChip>
            Période : {dateLabel}
          </FilterChip>
        )}

        {search && (
          <FilterChip>
            Recherche : {search}
          </FilterChip>
        )}

        {onlyWithConvocations && (
          <FilterChip tone="emerald">
            Avec convocations
          </FilterChip>
        )}
      </div>

      {resultCount > 0 && (
        <p className="shrink-0 text-xs text-slate-500 dark:text-slate-400">
          {displayedCount} affiché
          {displayedCount > 1 ? "s" : ""}
          {" · "}
          page {page}/{pageCount}
        </p>
      )}
    </div>
  );
}